import axios from "axios";

const baseURL = `${process.env.REACT_APP_API_URL}`;

const useAxios = () => {
  const axiosInstance = axios.create({
    baseURL,
  });

  axiosInstance.interceptors.request.use(async (req) => {
    return req;
  });

  return axiosInstance;
};

export default useAxios;
